/*
 * @Author:
 * @Date:
 * @LastEditTime:
 * @LastEditors:
 * @Description:
 * @FilePath:
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import LoginPage from '@/pages/account/login-page.vue'
import productCenter from '@/pages/productCenter.vue'
import maintenance from '@/pages/maintenance.vue'
import academy from '@/pages/academy.vue'
import download from '@/pages/download.vue'
import spareParts from '@/pages/spareParts.vue'
import aboutUs from '@/pages/aboutUs.vue'
import banner from '@/pages/banner.vue'
import AdminLayout from '@/pages/admin-layout'

// 保存原始的 push 和 replace 方法
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// 重写 push 方法
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 重写 replace 方法
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/admin',
    name: 'admin-layout',
    component: AdminLayout,
    redirect: {
      name: 'productCenter'
    },
    children: [
      {
        path: 'banner',
        name: 'banner',
        component: banner
      },
      {
        path: 'productCenter',
        name: 'productCenter',
        component: productCenter
      },
      {
        path: 'maintenance',
        name: 'maintenance',
        component: maintenance
      },
      {
        path: 'academy',
        name: 'academy',
        component: academy
      },
      {
        path: 'download',
        name: 'download',
        component: download
      },
      {
        path: 'spareParts',
        name: 'spareParts',
        component: spareParts
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        component: aboutUs
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
